import React from 'react';
import PlatformServicePage from './PlatformServicePage';
const WhatsAppServices: React.FC = () => <PlatformServicePage platform="whatsapp" />;
export default WhatsAppServices;
